import { Icon } from "@iconify/react";
import { Add, Check, Refresh } from "@mui/icons-material";
import { useMutation, useQuery } from "@tanstack/react-query";
import Spinner from "Components/CommonComponents/Spinner";
import AddStockUtil from "Components/Pages/Gdev/Trading/AddStockUtil";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  addStockImages,
  addStocks,
  fetchAllRfidData,
  fetchLabelledStocks,
  getLabelledStocks,
  updateLabelledStock,
} from "services/stockService";
import { generateDropDownList, looseDiamondId } from "utils/helpers";
import {
  makeAddStockFormatData,
  makeUpdateStockFormatData,
} from "utils/stockHelpers";
import StockStonePopUp from "./StockStonePopUp";
import StockImageUpload from "./StockImageUpload";
import { GenerateLabel } from "Components/Other Functions/GenerateLabel";
import { useSelector } from "react-redux";
import StockStonePopUpNew from "./StockStonePopUpNew";

const styles = {
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },
  innerContainer: {
    width: "98%",
    padding: "10px 25px 10px 10px",
    borderRadius: "5px",
    background: "#f4f4f4",
  },
  tableWrapper: {
    overflowX: "auto",
    maxHeight: "400px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    background: "#fff",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "600px",
  },
  th: {
    padding: "7px",
    // border: "1px solid black",
    textAlign: "center",
    backgroundColor: "#627383",
    color: "#FFFFFF",
    position: "sticky",
    top: 0,
    // zIndex: 2,
  },
  td: {
    padding: "10px",
    border: "1px solid black",
    textAlign: "left",
  },
  inputWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    width: "100%",
    padding: "5px",
    border: "1px solid #ddd",
    background: "white",
    boxSizing: "border-box",
  },
  select: {
    control: (provided) => ({
      ...provided,
      border: "1px solid #ddd",
      background: "white",
    }),
  },
  button: {
    marginTop: "10px",
    padding: "8px 12px",
    background: "blue",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
  },
};
const StockTable = ({
  itemfields,
  dropdownListData,
  allCollections,
  allPackets,
  allBoxes,
  selectStylee,
  stockData,
  ClientCode,
  EmployeeCode,
  VendorName,
  vendorTounchList,
  isEdit = false,
  editId = null,
  excelResponse = [],
  vendorList,
  SKUId,
  LotList,
  skuList,
  isDataFromExcel,
  setMainStoneList,
  setWeightCategoryList,
  itemfieldsLooseDiamonds,
}) => {
  console.log(itemfields);
  const {
    data: LabelledList,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["stock/addstock/getLabelledList", ClientCode],
    queryFn: fetchLabelledStocks,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: RfidData } = useQuery({
    queryKey: ["stock/addstock/getAllRfidData", ClientCode],
    queryFn: fetchAllRfidData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);

  const navigate = useNavigate();
  const [popup, setPopUp] = useState();
  const [itemsForImages, setItemsForImages] = useState([]);
  const [imagesToUpdate, setImagesToUpdate] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    getValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      items: [{supplier:""}], // Initial single row
    },
  });
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "items",
  });
  const {
    data: stock,
    isError: stockIsError,
    isPending: stockIsLoading,
    isSuccess: stockIsSuccess,
    mutate,
  } = useMutation({ mutationFn: addStocks });

  const {
    data: uploadedImages,
    isError: uploadImagesIsError,
    isPending: uploadImagesIsLoading,
    isSuccess: uploadImagesIsSuccess,
    mutate: uploadImages,
  } = useMutation({ mutationFn: addStockImages });

  const {
    data: UpdatedStock,
    isError: updateStockIsError,
    isPending: updateStockIsLoading,
    isSuccess: updateStockIsSuccess,
    mutate: updateStock,
  } = useMutation({ mutationFn: updateLabelledStock });

  const sortedItemFields = useMemo(() => {
    const fieldss = fields?.length
      ? fields[0]?.CategoryId?.value != looseDiamondId
        ? itemfields
        : itemfieldsLooseDiamonds
      : itemfields;
    console.log(fieldss);
    const filtereds = fieldss
      ?.filter(
        (field) =>
          field?.place === "grid" &&
          field.visibility !== "Hidden" &&
          field.IsVisible !== "Hidden"
      )
      ?.sort((a, b) => a.priority - b.priority);
    return filtereds;
  }, [itemfields, fields, itemfieldsLooseDiamonds]);



  useEffect(() => {
    if (stockData) {
      const data = Array.from({ length: stockData.Quantity }, () => stockData);
      console.log(data)
      replace(data); // Replaces all fields instead of just setting the value
    }
  }, [stockData, replace]);

  useEffect(() => {
    if (excelResponse?.length) {
      replace(excelResponse);
    }
  }, [excelResponse, replace]);

  useEffect(() => {
    if (stockIsError) {
      toast.error("Failed to add stock, try again later", {
        position: "top-center",
        duration: 3000,
      });
    }
    if (stockIsSuccess && stock?.length) {
      const uploadPromises = stock.map((item, idx) =>
        uplodImages({ ...item, Images: itemsForImages[idx]?.Images })
      );
      Promise.all(uploadPromises)
        .then((results) => {
          console.log("All images uploaded successfully:", results);
        })
        .catch((error) => {
          console.error("Error uploading images:", error);
        });
      toast.success("Stock added successfully", {
        position: "top-center",
        duration: 3000,
      });
      navigate(`/inventory_list`);
    }
  }, [stockIsError, stock, stockIsSuccess]);

  useEffect(() => {
    if (updateStockIsError) {
      toast.error("Failed to update stock, try again later", {
        position: "top-center",
        duration: 3000,
      });
    }
    if (updateStockIsSuccess) {
      updateImages(stockData);
      toast.success("Stock updated successfully", {
        position: "top-center",
        duration: 3000,
      });
      navigate(`/inventory_list`);
    }
  }, [updateStockIsError, updateStockIsSuccess]);

  const updateImages = async (payload) => {
   
    if (
      imagesToUpdate?.length &&
      imagesToUpdate?.filter((item) => item?.file != null)?.length
    ) {
      const formData = new FormData();
      formData.append("ClientCode", payload.ClientCode);
      formData.append("DesignId", payload.DesignId?.value);
      formData.append("ItemCode", payload.ItemCode);
      imagesToUpdate?.forEach((item) => {
        let idx = 1;
        if (item?.file != null) {
          formData.append(`file${idx}`, item.file);
          idx++;
        }
      });

      uploadImages({ payload: formData });
    }
  };
  useEffect(() => {}, [UpdatedStock]);
  useEffect(() => {
    if (stock?.length) {
      printLabel(stock);
    }
  }, [stock]);

  const printLabel = async (product) => {
    try {
      const res = await GenerateLabel(product, labelFormat);
    } catch (error) {
      toast?.error(
        "You do not have a label assigned. Please contact your administrator for assistance.",
        {
          duration: 4000,
          position: "top-center",
        }
      );
      console.log(error);
    }
  };

  const handleSubmitStock = () => {
    handleSubmit(onSubmit)();
  };
  const uplodImages = async (data) => {
    console.log(data);
    //   let images = data?.Images?.reduce((acc, item, idx) => {
    //     acc[`file${idx + 1}`] = item?.file;
    //     return acc;
    // }, {});
    let payload = {
      ClientCode: data?.ClientCode,
      DesignId: data?.DesignId,
      ItemCode: data?.ItemCode,
      Images: [...data?.Images],
    };

    const formData = new FormData();
    formData.append("ClientCode", payload.ClientCode);
    formData.append("DesignId", payload.DesignId);
    formData.append("ItemCode", payload.ItemCode);
    if (payload.Images?.length) {
      payload.Images?.forEach((item, idx) => {
        formData.append(`file${idx + 1}`, item.file);
      });
    }
    try {
      const data = await fetch(
        "https://rrgold.loyalstring.co.in/api/ProductMaster/UploadImagesByClientCode",
        {
          method: "POST",
          body: formData,
        }
      );
      if (!data.ok) {
        throw new Error(`${response.statusText || "Failed to upload image"}`);
      }
      return data?.json();
    } catch (error) {
      console.log(error);
    }
  };
  const onSubmit = async (data) => {
     console.log(data)
    if (isEdit) {
      setImagesToUpdate(data?.items[0]?.Images);
      const payload = makeUpdateStockFormatData({
        data,
        ClientCode,
        EmployeeCode,
      });
      updateStock({ payload });
    } else {
      setItemsForImages(data?.items);
      console.log(data)
      const payload = makeAddStockFormatData({
        data,
        ClientCode,
        EmployeeCode,
      });
      console.log(payload )
      console.log(payload)
      mutate({ payload });
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <div
          style={{
            width: "98%",
            padding: "10px 25px 10px 10px",
            borderRadius: "5px",
          }}
        >
          {/* Scrollable Table Container */}
          <div style={{ overflowX: "auto", maxHeight: "400px" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                // minWidth: "600px",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#627383",
                  color: "#FFF",
                }}
              >
                <tr>
                  {sortedItemFields?.length > 0 &&
                    sortedItemFields?.map((item) => (
                      <th
                        style={{ ...styles.th, minWidth: "400px" }}
                        key={item?.key}
                      >
                        {item?.label}
                      </th>
                    ))}

                  <th style={{ ...styles.th, width: "200px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((row, rowIndex) => (
                  <TableRow
                    key={row.id}
                    row={row}
                    rowIndex={rowIndex}
                    sortedItemFields={sortedItemFields}
                    watch={watch}
                    register={register}
                    control={control}
                    setValue={setValue}
                    setPopUp={setPopUp}
                    popup={popup}
                    dropdownListData={dropdownListData}
                    ClientCode={ClientCode}
                    vendorTounchList={vendorTounchList}
                    vendorList={vendorList}
                    allCollections={allCollections}
                    allPackets={allPackets}
                    allBoxes={allBoxes}
                    append={append}
                    remove={remove}
                    SKUId={SKUId}
                    allLabelledStockData={
                      LabelledList?.length ? LabelledList : []
                    }
                    RfidData={RfidData}
                    skuList={skuList}
                    isEdit={isEdit}
                    isDataFromExcel={isDataFromExcel}
                    setMainStoneList={setMainStoneList}
                    setWeightCategoryList={setWeightCategoryList}
                  />
                ))}
              </tbody>
            </table>
            {/* <button type="button" >
            ➕ Add Row
          </button> */}
          </div>

          {/* Add Row Button */}
          {/* <button style={styles.button}>➕ Add Row</button> */}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          gap: "10px",
        }}
      >
        <button
          style={{
            fontSize: "12px", // Smaller font size for responsiveness
            backgroundColor: "#0077d4",
            padding: "4px 6px", // Adjusted padding
            display: "flex",
            alignItems: "center",
            gap: "5px",
            flex: "1 1 auto", // Allows buttons to shrink proportionally
            minWidth: "100px", // Minimum button width
            maxWidth: "150px", // Prevents overly wide buttons
          }}
          type="button"
          onClick={handleSubmitStock}
          disabled={
            (stockIsLoading || updateStockIsLoading) &&
            !stockIsError &&
            !updateStockIsError
          }
        >
          {isEdit ? (
            <>
              {updateStockIsLoading && !updateStockIsError ? (
                <Spinner />
              ) : (
                <Check size={20} />
              )}{" "}
              {"Update"}
            </>
          ) : (
            <>
              {stockIsLoading && !stockIsError ? (
                <Spinner />
              ) : (
                <Check size={20} />
              )}{" "}
              {"Save"}
            </>
          )}
        </button>

        <button
          type="button"
          onClick={() => {
            if (isEdit) {
              navigate(`/edit_stock_labelled_unlabelled/${editId}`);
            } else {
              navigate(`/add_stock_labelled_unlabelled`);
            }
          }}
          style={{
            background: "#fff",
            fontSize: "12px", // Smaller font size for responsiveness
            color: "#0077D4",
            padding: "4px 6px", // Adjusted padding
            display: "flex",
            alignItems: "center",
            gap: "5px",
            border: "1px solid #0077D4",
            flex: "1 1 auto",
            minWidth: "100px",
            maxWidth: "150px",
          }}
          // disabled={invoiceCreateLoading}
        >
          <Refresh size={20} /> {/* Adjusted icon size */}
          Reset
        </button>

        <button
          onClick={() => {
            navigate(`/inventory_list`);
          }}
          type="button"
          style={{
            fontSize: "12px", // Smaller font size for responsiveness
            backgroundColor: "#0077d4",
            padding: "4px 6px", // Adjusted padding
            display: "flex",
            alignItems: "center",
            gap: "5px",
            flex: "1 1 auto",
            minWidth: "100px",
            maxWidth: "150px",
          }}
          // disabled={invoiceCreateLoading}
        >
          <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
          {/* Adjusted icon size */}
          Labelled List
        </button>
        <button
          // onClick={() => {
          //   navigate(`#`);
          // }}
          type="button"
          style={{
            fontSize: "12px", // Smaller font size for responsiveness
            backgroundColor: "#0077d4",
            padding: "4px 6px", // Adjusted padding
            display: "flex",
            alignItems: "center",
            gap: "5px",
            flex: "1 1 auto",
            minWidth: "100px",
            maxWidth: "150px",
          }}
          // disabled={invoiceCreateLoading}
        >
          <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
          {/* Adjusted icon size */}
          Unlabelled List
        </button>
      </div>
    </>
  );
};

export default StockTable;

const TableRow = ({
  row,
  rowIndex,
  sortedItemFields,
  watch,
  register,
  control,
  setValue,
  SKUId,
  dropdownListData,
  ClientCode,
  vendorTounchList,
  vendorList,
  allCollections,
  allPackets,
  allBoxes,
  append,
  remove,
  allLabelledStockData,
  RfidData,
  skuList,
  isDataFromExcel,
  isEdit,
  setMainStoneList,
  setWeightCategoryList,
}) => {
  const [popup, setPopUp] = useState({ status: false, label: "" });
  const VendorName = watch(`items.${rowIndex}.VendorId`);
  const StockKeepingUnit = watch(`items.${rowIndex}.SKUId`);
  const CategoryId = watch(`items.${rowIndex}.CategoryId`);
  const ProductId = watch(`items.${rowIndex}.ProductId`);
  const DesignId = watch(`items.${rowIndex}.DesignId`);
  const PurityId = watch(`items.${rowIndex}.PurityId`);
  const GrossWt = watch(`items.${rowIndex}.GrossWt`);
  const TotalStoneWeight = watch(`items.${rowIndex}.TotalStoneWeight`);
  const DiamondWeight = watch(`items.${rowIndex}.DiamondWeight`);
  const PackingWeight = watch(`items.${rowIndex}.PackingWeight`);
  const TotalWeight = watch(`items.${rowIndex}.TotalWeight`);
  const Stones = watch(`items.${rowIndex}.Stones`);
  const RFIDCode = watch(`items.${rowIndex}.RFIDCode`);
  const Pieces = watch(`items.${rowIndex}.Pieces`);
  const Images = watch(`items.${rowIndex}.Images`);
  const ItemCode = watch(`items.${rowIndex}.ItemCode`);

  useEffect(() => {
    if (dropdownListData?.categories?.length && CategoryId?.value) {
      const foundCat = dropdownListData?.categories?.find(
        (item) => item?.Id == CategoryId?.value
      );
      setValue(`items.${rowIndex}.HSNCode`, foundCat?.HSNCode);
    } else {
      setValue(`items.${rowIndex}.HSNCode`, "");
    }
  }, [CategoryId]);


  
  useEffect(() => {
    setValue(
      `items.${rowIndex}.GrossWt`,
      ((+(TotalWeight) || 0) - (+(PackingWeight) || 0))?.toFixed(3)
    );
  }, [TotalWeight, PackingWeight,]);

  useEffect(() => {
    setValue(
      `items.${rowIndex}.NetWt`,
      (+(GrossWt || 0) - ((+(TotalStoneWeight || 0) || 0)
      // /5
    )  - (+(DiamondWeight || 0)
    //  / 5
    ))?.toFixed(3)
    );
  }, [GrossWt, TotalStoneWeight,DiamondWeight]);

  useEffect(() => {
    if (RFIDCode && !isEdit) {
      const isBarcodeInUse = allLabelledStockData.some(
        (item) => item.RFIDCode === RFIDCode && item.Status !== "Sold"
      );
      if (isBarcodeInUse) {
        toast.error(`${RFIDCode} is already assigned for another product.`, {
          position: "top-center",
          duration: 2000,
        });
      } else {
        const matchingProduct = RfidData?.find(
          (item) => item.BarcodeNumber == RFIDCode
        );
        console.log(matchingProduct);
        setValue(
          `items.${rowIndex}.TIDNumber`,
          matchingProduct?.TidValue || null
        );
      }
    }
  }, [RFIDCode]);

  useEffect(() => {
    if (!isEdit && StockKeepingUnit) {
      const foundSku = skuList?.find(
        (item) => item?.Id === StockKeepingUnit?.value
      );
      let packingWt = 0;
      if (+(foundSku?.ClipWeight || 0))
        packingWt += +(foundSku?.ClipWeight || 0);
      if (+(foundSku?.LanyardWeight || 0))
        packingWt += +(foundSku?.LanyardWeight || 0);
      if (+(foundSku?.PouchWeight || 0))
        packingWt += +(foundSku?.PouchWeight || 0);
      if (+(foundSku?.TagWeight || 0)) packingWt += +(foundSku?.TagWeight || 0);
      if (+(foundSku?.FindingWeight || 0))
        packingWt += +(foundSku?.FindingWeight || 0);
      if (+(foundSku?.OtherWeight || 0))
        packingWt += +(foundSku?.OtherWeight || 0);
      if (foundSku) {
        const fields = {
          CategoryId: +(foundSku?.CategoryId || 0) && {
            value: foundSku.CategoryId,
            label: foundSku.CategoryName,
          },
          ProductId: +(foundSku?.ProductId || 0) && {
            value: foundSku.ProductId,
            label: foundSku.ProductName,
          },
          DesignId: +(foundSku?.DesignId || 0) && {
            value: foundSku.DesignId,
            label: foundSku.DesignName,
          },
          PurityId: +(foundSku?.PurityId || 0) && {
            value: foundSku.PurityId,
            label: foundSku.PurityName,
          },
          CollectionId: +(foundSku?.CollectionId || 0) && {
            value: foundSku.CollectionId,
            label: foundSku.CollectionName,
          },
          BoxId: +(foundSku?.BoxId || 0) && {
            value: foundSku.BoxId,
            label: foundSku.BoxName,
          },
          Quantity: foundSku.Quantity,
          TotalWeight: +(packingWt || 0)
            ? (+(foundSku.GrossWt || 0) + (packingWt || 0))?.toFixed(3)
            : (+(foundSku.GrossWt || 0))?.toFixed(3),
          TotalStoneWeight: foundSku.TotalStoneWeight,
          Pieces: foundSku.Pieces,
          MakingPercentage: foundSku.MakingPercentage,
          MakingPerGram: foundSku.MakingPerGram,
          MakingFixedAmt: foundSku.MakingFixedAmt,
          MakingFixedWastage: foundSku.MakingFixedWastage,
          MRP: foundSku.MRP,
          ClipWeight: foundSku.ClipWeight,
          OtherWeight: foundSku.OtherWeight,
          PouchWeight: foundSku.PouchWeight,
          TagWeight: foundSku.TagWeight,
          FindingWeight: foundSku.FindingWeight,
          LanyardWeight: foundSku.LanyardWeight,
          Description: foundSku.Description,
          Gender: foundSku.Gender,
          Size: foundSku.Size,
        };
        Object.entries(fields).forEach(([key, value]) =>
          setValue(`items.${rowIndex}.${key}`, value || "")
        );
        if (foundSku?.SKUStoneMain?.length) {
          setMainStoneList(foundSku.SKUStoneMain);
        }
        if (foundSku?.WeightCategories && foundSku?.WeightCategories != "0") {
          const list = foundSku?.WeightCategories?.split(",")?.map((item) => {
            return { value: item, label: item };
          });
          console.log(list);
          setWeightCategoryList(list);
        }
      }
    }
  }, [isDataFromExcel, skuList, StockKeepingUnit,isEdit]);

  // useEffect(() => {
  //   if (Stones?.length) {
  //     let totalWeight = Stones?.reduce((acc, curr) => {
  //       return acc + +(curr?.StoneWeight || 0);
  //     }, 0);
  //     console.log();
  //     setValue(`items.${rowIndex}.TotalStoneWeight`, totalWeight);
  //   }
  // }, [Stones]);

  return (
    <>
      {/* {popup?.status && popup?.label == "Stones" && (
        <StockStonePopUp
          key={rowIndex}
          onClose={() => setPopUp({ status: false, label: "" })}
          dropdownListData={dropdownListData}
          clientCode={ClientCode}
          VendorName={VendorName}
          StockKeepingUnit={StockKeepingUnit}
          
          // addedStones={addedStones && addedStones?.length ? addedStones : []}
          addedStones={watch(`items.${popup.rowIndex}.Stones`) || []}
          vendorTounchList={vendorTounchList}
          addStone={(data) => {
            let totalStWt = 0
            let totalStoneAmt = 0
            data?.stones?.forEach((item)=>{
              if(item?.StoneStatusType != "dontDeduct"){
                totalStWt += (+(item?.StoneWeight ||0))
                totalStoneAmt += (+(item?.StoneAmount || 0))
              }
            })
           
            setValue(`items.${popup.rowIndex}.Stones`, data?.stones);
            setValue(`items.${popup.rowIndex}.TotalStoneWeight`, (totalStWt * +(Pieces || 0))?.toFixed(3));
            setValue(`items.${popup.rowIndex}.TotalStoneAmount`, (totalStoneAmt * +(Pieces || 0))?.toFixed(2));
            setPopUp({ status: false, label: "" });
          }}
        />
      )} */}

      {popup?.status && popup?.label == "Stones" ? (
        <StockStonePopUpNew
          onClose={() => setPopUp({ status: false, label: "" })}
          dropdownListData={dropdownListData}
          addStone={(data) => {
            console.log(data);
            let totalStWt = 0;
            let totalStoneAmt = 0;
            data?.stones?.forEach((item) => {
              if (item?.StoneStatusType != "dontDeduct") {
                totalStWt += +(item?.StoneWeight || 0);
                totalStoneAmt += +(item?.StoneAmount || 0);
              }
            });
            setValue(`items.${popup.rowIndex}.Stones`, data?.stones);
            setValue(
              `items.${popup.rowIndex}.TotalStoneWeight`,
              (+(totalStWt * (+(Pieces || 0) || 1)))?.toFixed(3)
            );
            setValue(
              `items.${popup.rowIndex}.TotalStoneAmount`,
              (+(totalStoneAmt * (+(Pieces || 0) || 1)))?.toFixed(2)
            );
            setPopUp({ status: false, label: "" });
          }}
          clientCode={ClientCode}
          Stones={watch(`items.${popup.rowIndex}.Stones`) || []}
          StockKeepingUnit={StockKeepingUnit}
          skuList={skuList}
        />
      ) : (
        ""
      )}
      {popup?.status && popup?.label == "IButton" && (
        <StockImageUpload
          // key={rowIndex}
          // onClose={() => setPopUp({ status: false, label: "" })}
          // dropdownListData={dropdownListData}
          // clientCode={ClientCode}
          // VendorName={VendorName}
          // addedStones={watch(`items.${popup.rowIndex}.Stones`) || []}
          // vendorTounchList={vendorTounchList}
          // addStone={(data) => {
          //   console.log(data);
          //   console.log(rowIndex);
          //   setValue(`items.${popup.rowIndex}.Stones`, data?.stones);
          //   setPopUp({ status: false, label: "" });
          // }}
          isEdit={isEdit}
          isOpen={popup?.status}
          onClose={() => setPopUp({ status: false, label: "IButton" })}
          defaulImages={Images && Images?.length ? Images : []}
          onSave={(images) => {
            console.log(images);
            setValue(`items.${rowIndex}.Images`, images);
          }}
          ClientCode={ClientCode}
          ItemCode={isEdit && ItemCode ? ItemCode : ""}
        />
      )}

      <tr key={row.id}>
        {sortedItemFields?.map((field, fieldIndex) => (
          <td
            key={field.key}
            style={{
              padding: "10px",
              border: "1px solid #ddd",
              minWidth: "400px",
              maxWidth: "400px",
            }}
          >
            <div>
              {/* <label title={field.label}>
                {field.label.substring(0, 14)}{" "}
                {field.label?.length > 14 && "..."}
                {field?.mandatory && <span style={{ color: "red" }}>*</span>}
              </label> */}

              {field.type === "inputselect" ||
              field.type === "inputnumber" ||
              field.type === "inputdecimal" ||
              field.type === "inputtext" ? (
                <input
                  type="text"
                  name={`items.${rowIndex}.${field.key}`}
                  disabled={
                    field.key === "GrossWt" ||
                    (field?.key == "RFIDCode" && isEdit)
                  }
                  {...register(`items.${rowIndex}.${field.key}`, {
                    required:
                      field?.mandatory &&
                      field.visibility !== "ReadOnly" &&
                      `${field.label} is required`,
                    onChange: (e) => {
                      if (field.key === "RFIDCode") {
                        const uppercaseValue = e.target.value.toUpperCase();
                        setValue(
                          `items.${rowIndex}.${field.key}`,
                          uppercaseValue,
                          {
                            shouldValidate: true,
                          }
                        );
                      }
                    },
                  })}
                  autoComplete="off"
                  style={{
                    width: "100%",
                    background: "white",
                    border: "1px solid #ddd",
                    padding: "5px",
                    boxSizing: "border-box",
                    height: "35px",
                    minWidth: "100px",
                    backgroundColor: "#fff",
                    textAlign: "center",
                  }}
                  onKeyDown={(e) => {
                    if (e?.code === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
              ) : field.type === "dropdown" ||
                field.type === "searchDropdown" ? (
                <Controller
                  name={`items.${rowIndex}.${field.key}`}
                  control={control}
                  rules={{
                    required:
                      field?.mandatory &&
                      field.visibility !== "ReadOnly" &&
                      `${field.label} is required`,
                    validate: (value) => {
                      if (
                        field?.mandatory &&
                        field.visibility !== "ReadOnly" &&
                        value?.value === ""
                      ) {
                        return `${field.label} cannot be empty`;
                      }
                    },
                  }}
                  render={({ field: controllerField }) => (
                    <Select
                      {...controllerField}
                      options={generateDropDownList({
                        field,
                        dropdownListData,
                        CategoryId,
                        ProductId,
                        DesignId,
                        PurityId,
                        skus: [],
                        VendorName,
                        allCollections,
                        allPackets,
                        allBoxes,
                        vendorList,
                      })?.map((item) => ({
                        value: item?.value,
                        label: item?.label,
                      }))}
                      isDisabled={
                        field.visibility === "ReadOnly" ||
                        ((field.key == "CategoryId" ||
                          field.key == "ProductId" ||
                          field.key == "DesignId" ||
                          field.key == "PurityId") &&
                          StockKeepingUnit?.value) ||
                        (field?.key == "SKUId" && isDataFromExcel)
                      }
                      isClearable={true}
                      isSearchable={true
                        // field.type === "searchDropdown"
                      }
                      menuPlacement="top"
                      styles={{
                        control: (base) => ({
                          ...base,
                          width: "100%",
                          minHeight: "35px",
                          borderColor: "#ddd",
                          minWidth: "150px",
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "100%",
                          zIndex: 9999, // Ensure dropdown appears on top
                          position: "absolute",
                          maxHeight: "200px", // Limit height for scrolling
                          overflowY: "auto", // Enable vertical scrollbar
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensures dropdown is rendered in a separate portal
                        }),
                      }}
                      menuPortalTarget={document.body}
                    />
                  )}
                />
              ) : field.type === "popup" ? (
                // <div >
                //   <div className="input-group" style={{ position: "relative" }}>
                //     <input
                //       id="stone-input"
                //       type="button"
                //       style={{ margin: 0 }}
                //       className="input-field"
                //     />
                //     <Add
                //       type="button"
                //       size={28}
                //       onClick={() => {
                //         console.log("workign");
                //         console.log(field.key);
                //         setPopUp({
                //           status: true,
                //           label: field.key,
                //           rowIndex,
                //         });
                //       }}
                //       style={{
                //         background: "#A9A9A9",
                //         cursor: "pointer",
                //         height: "100%",
                //         color: "white",
                //       }}
                //     />
                //   </div>
                // </div>
                <div>
  <div className="input-group" style={{ position: "relative" }}>
  <button
  id="stone-input"
  type="button"
  className="input-field"
  onMouseEnter={(e) => {
    e.target.style.background = "#888"; // hover color
  }}
  onMouseLeave={(e) => {
    e.target.style.background = "#A9A9A9"; // original color
  }}
  onFocus={(e) => {
    e.target.style.border = "2px solid #005eff"; // focus border
  }}
  onBlur={(e) => {
    e.target.style.border = "none"; // remove focus border
  }}
  style={{
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#A9A9A9",
    cursor: "pointer",
    height: "100%",
    border: "none",
    color: "white",
    padding: "0.5rem 1rem",
    borderRadius: "4px",
    transition: "all 0.2s ease-in-out",
    outline: "none",
  }}
  onClick={() => {
    console.log("working");
    console.log(field.key);
    setPopUp({
      status: true,
      label: field.key,
      rowIndex,
    });
  }}
>
  <Add size={28} />
</button>

  </div>
</div>

              ) : null}
            </div>
          </td>
        ))}

        <td>
          <FaPlus
            type="button"
            size={18}
            style={{
              cursor: "pointer",
              color: "#A9A9A9",
              marginRight: "5px",
            }}
            onClick={() => append({})}
          />
          <FaTrashAlt
            type="button"
            size={18}
            style={{ cursor: "pointer", color: "#A9A9A9" }}
            onClick={() => remove(rowIndex)}
          />
        </td>
      </tr>
    </>
  );
};
